/**
 * EL TONO DE LLAMADA (01/10/2026: "con una especie de sonido tipo FaceTime cuando te llaman").
 *
 * Generado con Web Audio, sin archivo de sonido: un arpegio ascendente corto y brillante (dos
 * frases de tres notas con un respiro), que se repite mientras suena el timbre. Volumen moderado,
 * envolvente suave para que no "pique". Si el navegador no deja reproducir audio (sin interacción
 * previa en la página), no suena y no rompe nada.
 */
const FRASE = [659.25, 830.61, 987.77];           // Mi5, Sol#5, Si5
const NOTA_S = 0.16, ENTRE_NOTAS_S = 0.13, ENTRE_FRASES_S = 0.42, CICLO_S = 2.4;

export function sonarTonoDeLlamada(): () => void {
  let ctx: AudioContext | null = null;
  try {
    const AC = window.AudioContext ?? (window as unknown as { webkitAudioContext?: typeof AudioContext }).webkitAudioContext;
    if (!AC) return () => undefined;
    ctx = new AC();
  } catch { return () => undefined; }
  const audio = ctx;
  void audio.resume().catch(() => undefined);
  const salida = audio.createGain();
  salida.gain.value = 0.22;
  salida.connect(audio.destination);

  const nota = (frec: number, t: number) => {
    for (const [mult, vol] of [[1, 1], [2, 0.18]] as const) {          // fundamental + un brillo
      const o = audio.createOscillator(), g = audio.createGain();
      o.type = 'sine'; o.frequency.value = frec * mult;
      g.gain.setValueAtTime(0.0001, t);
      g.gain.exponentialRampToValueAtTime(vol, t + 0.015);
      g.gain.exponentialRampToValueAtTime(0.0001, t + NOTA_S + 0.25);
      o.connect(g); g.connect(salida);
      o.start(t); o.stop(t + NOTA_S + 0.3);
    }
  };
  const ciclo = () => {
    const t0 = audio.currentTime + 0.05;
    for (let f = 0; f < 2; f++) FRASE.forEach((frec, i) => nota(frec, t0 + f * (FRASE.length * ENTRE_NOTAS_S + ENTRE_FRASES_S) + i * ENTRE_NOTAS_S));
  };
  ciclo();
  const t = setInterval(ciclo, CICLO_S * 1000);
  return () => { clearInterval(t); salida.gain.setTargetAtTime(0, audio.currentTime, 0.05); setTimeout(() => void audio.close().catch(() => undefined), 400); };
}
